import { SettingsActions } from '../redux/settings/settings.actions';

export type LegalDocumentMapper = (documentType: string) => string;
export const legalDocumentMapper: LegalDocumentMapper = (documentType: string) => {
  switch (documentType) {
    case SettingsActions.showDataPrivacyAdditionAI.type:
      return 'data_privacy_addition_ai';
    case SettingsActions.showDataPrivacy.type:
      return 'data_privacy';
    case SettingsActions.showTermsAndConditions.type:
      return 'terms_and_conditions';
    default:
      throw new Error('Can not map Legal document type');
  }
};
